import { supabase } from "@/api/supabaseClient";

export type OrganizationRow = {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  is_active: boolean;
};

export type MyMembership = {
  id: string;
  organization_id: string;
  profile_id: string;
  status: "invited" | "active" | "disabled";
  organization: OrganizationRow | null;
  roles: ("caregiver" | "medicus" | "board" | "organizer" | "admin")[];
};

export class OrganizationsApi {
  /**
   * Eigene Mitgliedschaften (active/invited) inkl. Rollen.
   * userId kommt vom Aufrufer (dieselbe ID wie im Query-Key).
   * Ohne User-ID gibt es keine Abfrage. RLS bleibt die Autorität.
   */
  static async listMyMemberships(
    userId: string | null | undefined
  ): Promise<MyMembership[]> {
    if (!userId) return [];

    const { data, error } = await supabase
      .from("memberships")
      .select(
        `
        id,
        organization_id,
        profile_id,
        status,
        organization:organizations ( id, name, slug, logo_url, is_active ),
        membership_roles ( role )
      `
      )
      .eq("profile_id", userId)
      .in("status", ["active", "invited"])
      .order("created_at", { ascending: true });

    if (error) throw error;

    return (data ?? []).map((row: any) => ({
      id: row.id,
      organization_id: row.organization_id,
      profile_id:
        typeof row.profile_id === "string" ? row.profile_id : userId,
      status: row.status,
      organization: Array.isArray(row.organization)
        ? row.organization[0] ?? null
        : row.organization ?? null,
      roles: (row.membership_roles ?? []).map((r: { role: string }) => r.role),
    }));
  }

  static async activateMyMemberships(): Promise<number> {
    const { data, error } = await supabase.rpc("activate_my_memberships");
    if (error) throw error;
    return typeof data === "number" ? data : 0;
  }
}
